module.exports = __webpack_public_path__ + "static/media/WarningCircle.f0470529.svg";